import { action, observable, computed } from 'mobx';
import moment from 'moment';

import logger from 'logger';
import ProfileService from 'services/ProfileService';
import { compareDates } from 'utils/helpers';


class UpcomingShowsStore {
  @observable upcomingShows = [];

  @action getUpcomingShows = (performerName) => {
    ProfileService.getUpcomingShows(performerName)
      .then((response) => {
        this.upcomingShows = response;
      })
      .catch((err) => logger.error(err));
  };

  @computed get firstThreeShows() {
    return this.upcomingShows
      .sort((show1, show2) => compareDates(show1.startDate, show2.startDate))
      .slice(0, 3)
      .map((show) => {
        const momentDate = moment(show.startDate);

        return {
          dateNumber: momentDate.date(),
          monthName: momentDate.format('MMMM'),
          showTime: momentDate.format('hh:mm a'),
        };
      });
  }

  @computed get isThereShow() {
    return this.upcomingShows.length > 0;
  }
}

export default new UpcomingShowsStore();
